<script setup></script>

<template>
  <div class="bg-white">
    <slot></slot>
  </div>
</template>

<style scoped></style>
